import React from 'react';
import { headingNotSet, subHeadingNotSet } from '../../services/TemplateUtils';
import { StyledHeading } from '../styles/styles';
import { ImageCarouselProps } from './imageCarouselTypes';

interface ImageCarouselHeadingsProps {
  heading: ImageCarouselProps['heading'];
  tone?: ImageCarouselProps['tone'];
}

export default function ImageCarouselHeadings({ heading, tone }: ImageCarouselHeadingsProps) {
  return (
    <>
      {!headingNotSet(heading) && (
        <StyledHeading headerVariant="heading2" tone={tone}>
          {heading.content}
        </StyledHeading>
      )}
      {!subHeadingNotSet(heading) && (
        <StyledHeading headerVariant="subheading" tone={tone}>
          {heading.subHeader}
        </StyledHeading>
      )}
    </>
  );
}
